document.querySelectorAll(`.cc-product-switch-tabs input[type="radio"]`).forEach(radio => {
    radio.addEventListener('change', () => {
      document.querySelectorAll(".cc-product-switch-tabs .tab-images").forEach(tab => tab.classList.remove('active'));
      const index = radio.id.replace('tab-', '');
      const targetTab = document.querySelector(`.cc-product-switch-tabs .tab-images[data-tab-index="${index}"]`);
      if (targetTab) {
        targetTab.classList.add('active');
      }
    });
  });